import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
  ISignUpResult,
  CognitoUserAttribute,
} from "amazon-cognito-identity-js"
import { getDomain } from "../helper"

// Production Cognito credentials
const PROD_CONFIG = {
  UserPoolId: 'ap-south-1_lVP9oxqa4',
  ClientId: '59kno0mf95j4tqo7aot1sr2diq',
}

// Demo Cognito credentials (you can update these with actual demo credentials)
const DEMO_CONFIG = {
  UserPoolId: 'ap-south-1_IQWsi7b4S',  // Replace with actual demo UserPoolId
  ClientId: '2nb6jn84ogfsusd8l7f17812sq',    // Replace with actual demo ClientId
}

// Determine which config to use based on domain
const getPoolConfig = () => {
  const domain = getDomain();
  console.log("domain",domain);
  
  return domain === 'demo' ? DEMO_CONFIG : PROD_CONFIG;
}

const userPool = new CognitoUserPool(getPoolConfig())

export function signUpCognitoUser(username: string, email: string, password: string): Promise<CognitoUser | undefined> {
  return new Promise((resolve, reject) => {
    const attributeList = [
      new CognitoUserAttribute({ Name: "email", Value: email })
    ]

    userPool.signUp(email, password, attributeList, [], (err, result) => {
      if (err) {
        reject(err)
        return
      }
      resolve(result?.user)
    })
  })
}

export function confirmSignUp(username: string, code: string): Promise<CognitoUser | undefined> {
  return new Promise((resolve, reject) => {
    const cognitoUser = new CognitoUser({
      Username: username,
      Pool: userPool,
    })

    cognitoUser.confirmRegistration(code, true, (err, result) => {
      if (err) {
        reject(err)
        return
      }
      resolve(result)
    })
  })
}

export function signInCognitoUser(username: string, password: string): Promise<CognitoUser | undefined> {
  return new Promise((resolve, reject) => {
    const authenticationDetails = new AuthenticationDetails({
      Username: username,
      Password: password,
    })

    const cognitoUser = new CognitoUser({
      Username: username,
      Pool: userPool,
    })

    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: (result: any) => {
        resolve(result)
      },
      onFailure: (err) => {
        reject(err)
      },
    })
  })
}

export function forgotPassword(username: any) {
  const user = new CognitoUser({
    Username: username,
    Pool: userPool,
  });

  return new Promise((resolve, reject) => {
    user.forgotPassword({
      onSuccess: () => resolve('Email sent'),
      onFailure: (err) => reject(err),
    });
  });
}

export function verifyOTP(username: string, code: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({ Username: username, Pool: userPool });
    user.confirmPassword(code, '', { // blank newPassword, just confirm step
      onSuccess: () => resolve(),
      onFailure: (err: Error) => reject(err),
    });
  });
}

export function confirmPassword(username: any, code: any, newPassword: any) {
  const user = new CognitoUser({
    Username: username,
    Pool: userPool,
  });

  return new Promise((resolve, reject) => {
    user.confirmPassword(code, newPassword, {
      onSuccess: () => resolve('Password reset'),
      onFailure: (err) => reject(err),
    });
  });
}

export function signOutCognitoUser() {
  const cognitoUser = userPool.getCurrentUser()
  if (cognitoUser) {
    cognitoUser.signOut()
  }
  // Clear referral code from session storage on logout
  sessionStorage.removeItem('referral_code')
}

export function getCurrentCognitoUser() {
  return userPool.getCurrentUser()
}

export function getValidSession(): Promise<CognitoUser> {
  return new Promise((resolve, reject) => {
    const user = getCurrentCognitoUser()

    if (!user) {
      reject(new Error("No user is currently logged in"))
      return
    }

    user.getSession((err: any, session: any) => {
      if (err || !session?.isValid()) {
        reject(new Error("User is not authenticated"))
        return
      }
      resolve(user)
    })
  })
}

export function getSession() {
  const cognitoUser = userPool.getCurrentUser()
  return new Promise((resolve, reject) => {
    if (!cognitoUser) {
      reject(new Error("No user found"))
      return
    }
    cognitoUser.getSession((err: any, session: unknown) => {
      if (err) {
        reject(err)
        return
      }
      resolve(session)
    })
  })
}

export function resendVerificationCode(username: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({
      Username: username,
      Pool: userPool,
    });

    user.resendConfirmationCode((err, result) => {
      if (err) {
        reject(err);
        return;
      }
      resolve(result); // Typically "SUCCESS"
    });
  });
}


export function changeCognitoPassword(user: CognitoUser, oldPassword: string, newPassword: string): Promise<string> {
  return new Promise((resolve, reject) => {
    user.changePassword(oldPassword, newPassword, (err, result: any) => {
      if (err) {
        reject(err)
        return
      }
      resolve(result) // usually returns "SUCCESS"
    })
  })
}